import React from "react";
import ProductList from "../../components/Products/ProductList/Product.component";
import "./Product.scss";

function Product_page() {
  return <ProductList />;
}

export default Product_page;
